import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Endpoints, EnvironmentRef } from 'projects/tmhna-portal/src/environments/interfaces';
import { Observable } from 'rxjs/internal/Observable';
import { ApiResponse } from '../../definitions/api-response.interface';
import { expEnvironmentRef } from '../../injection-tokens/environment.injection-token';
import { jsonPaths, urlPaths } from  './api.url';

@Injectable({
	providedIn: 'root'
})
export class AemApiService
{
	public endpoints: Endpoints = this.environmentRef.endpoints;
	constructor(
		private readonly httpClient: HttpClient,
		@Inject(expEnvironmentRef) readonly environmentRef: EnvironmentRef
	) { }
	isRaymond : boolean | undefined = this.environmentRef?.isRaymond;
	public getHeaderNavValues(isTmhCorporateAdmin: boolean): Observable<ApiResponse>
	{
		const businessAccountHeader = this.isRaymond ? this.endpoints?.header.routes.headerendpoints.cmsbusinessaccountheaderraymond : this.endpoints?.header.routes.headerendpoints.aembusinessaccountheader;
		const path: string = isTmhCorporateAdmin? `${businessAccountHeader}` : `${this.endpoints?.header.routes.headerendpoints.aemheaders}`;
		return this.httpClient.get<ApiResponse>(path);
	}
	public getFooterData()
	{
		const url =  this.environmentRef.baseUrl + urlPaths.aemFooterData;
		return this.httpClient.get<ApiResponse>(url);
	}
	public getEquipmentLables()
	{
		const url: string = this.isRaymond ? jsonPaths.raymondEquipmentLabels : this.environmentRef.baseUrl + urlPaths.equipmentLabels;
		return this.httpClient.get<ApiResponse>(url);
	}
	public getPendingApprovalLabels()
	{
		const url: string = jsonPaths.pendingApprovalPageLabel;
		return this.httpClient.get<ApiResponse>(url);
	}
	public getPendingApprovalLabelsRaymond()
	{
		const url: string = jsonPaths.pendingApprovalPageLabelRaymond;
		return this.httpClient.get<ApiResponse>(url);
	}
	public getBusinessAccountSuccessPopupLabels()
	{
		const url: string = jsonPaths.businessAccountSuccessRegistrationLabels;
		return this.httpClient.get<ApiResponse>(url);
	}
	public getLandingPageLabels(): Observable<ApiResponse>
	{
		const url: string = this.environmentRef.baseUrl + urlPaths.landingPageLabels;
		return this.httpClient.get<ApiResponse>(url);
	}
	public getHeaderAlertBanner(): Observable<ApiResponse>
	{
		const url: string = this.environmentRef.baseUrl + (this.isRaymond ? urlPaths.headerAlertBannerRaymond : urlPaths.headerAlertBanner);
		return this.httpClient.get<ApiResponse>(url);
	}
	
	
	public loadFooterStyles(footerStyles : string) 
	{
		const head = document.getElementsByTagName('head')[0];
		const style = document.createElement('link');
		style.id = 'footer-theme';
		style.rel = 'stylesheet';
		style.type = 'text/css';
		style.href = footerStyles;
		head.appendChild(style);
	}
	
	public loadFooterScripts(footerScripts : {}) 
	{
		var newArrayDataOfOjbect = Object.values(footerScripts);
		newArrayDataOfOjbect.forEach(libSrc => this.injectLib(libSrc));
	}
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	public injectLib(src: any): void 
	{
		const script = document.createElement('script');
		script.src = src;
		document.body.appendChild(script);
	}
}
